// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Soup,
    Space,
    Spade,
    Sparkle,
    Sparkles,
    Speaker,
    Speech,
    SpellCheck,
    SpellCheck2,
    Spline,
    SplinePointer,
    Split,
    Spool,
    SportShoe,
    Spotlight,
    SprayCan,
    Sprout,
    Square,
    SquareActivity,
    SquareArrowDown,
    SquareArrowDownLeft,
    SquareArrowDownRight,
    SquareArrowLeft,
    SquareArrowOutDownLeft,
    SquareArrowOutDownRight,
    SquareArrowOutUpLeft,
    SquareArrowOutUpRight,
    SquareArrowRight,
    SquareArrowRightEnter,
    SquareArrowRightExit,
    SquareArrowUp,
    SquareArrowUpLeft,
    SquareArrowUpRight,
    SquareAsterisk,
    SquareBottomDashedScissors,
    SquareCenterlineDashedHorizontal,
    SquareCenterlineDashedVertical,
    SquareChartGantt,
    SquareCheck,
    SquareCheckBig,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "soup" through "square-check-big", inclusive. */
const shard: Record<string, LucideIcon> = {
    soup: Soup,
    space: Space,
    spade: Spade,
    sparkle: Sparkle,
    sparkles: Sparkles,
    speaker: Speaker,
    speech: Speech,
    "spell-check": SpellCheck,
    "spell-check-2": SpellCheck2,
    spline: Spline,
    "spline-pointer": SplinePointer,
    split: Split,
    spool: Spool,
    "sport-shoe": SportShoe,
    spotlight: Spotlight,
    "spray-can": SprayCan,
    sprout: Sprout,
    square: Square,
    "square-activity": SquareActivity,
    "square-arrow-down": SquareArrowDown,
    "square-arrow-down-left": SquareArrowDownLeft,
    "square-arrow-down-right": SquareArrowDownRight,
    "square-arrow-left": SquareArrowLeft,
    "square-arrow-out-down-left": SquareArrowOutDownLeft,
    "square-arrow-out-down-right": SquareArrowOutDownRight,
    "square-arrow-out-up-left": SquareArrowOutUpLeft,
    "square-arrow-out-up-right": SquareArrowOutUpRight,
    "square-arrow-right": SquareArrowRight,
    "square-arrow-right-enter": SquareArrowRightEnter,
    "square-arrow-right-exit": SquareArrowRightExit,
    "square-arrow-up": SquareArrowUp,
    "square-arrow-up-left": SquareArrowUpLeft,
    "square-arrow-up-right": SquareArrowUpRight,
    "square-asterisk": SquareAsterisk,
    "square-bottom-dashed-scissors": SquareBottomDashedScissors,
    "square-centerline-dashed-horizontal": SquareCenterlineDashedHorizontal,
    "square-centerline-dashed-vertical": SquareCenterlineDashedVertical,
    "square-chart-gantt": SquareChartGantt,
    "square-check": SquareCheck,
    "square-check-big": SquareCheckBig,
};

export default shard;
